export default "__VITE_ASSET__Du894PCx__"